import { render } from "./ImportanceOne.vue?vue&type=template&id=244f5385"
const script = {}

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__